import * as Yup from 'yup';

export const prisonerNameSchema = Yup.string().required('Поле пустое');
